<template>
	<v-menu
		ref="menu"
		v-model="menu"
		:close-on-content-click="false"
		:return-value.sync="iso_date"
		:disabled="disabled"
		transition="scale-transition"
		offset-y
		min-width="290px"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				v-model="show_date"
				:label="label"
				prepend-icon="event"
				append-icon="clear"
				readonly hide-details
				v-on="on"
				@click:append="iso_date = null"
			></v-text-field>
		</template>
		<v-date-picker v-model="iso_date" no-title scrollable>
			<v-spacer></v-spacer>
			<v-btn text color="primary" @click="menu = false">Cancel</v-btn>
			<v-btn text color="primary" @click="$refs.menu.save(iso_date)">OK</v-btn>
		</v-date-picker>
	</v-menu>
</template>

<script>
import { dateMixin } from "@/mixins/misc/dateMixin";

export default {
	mixins: [ dateMixin ],
	model: {
		prop: "date",
		event: "on_change"
	},
	props: {
		label: {
			type: String,
			default: "Date"
		},
		date: {
			type: Date,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			show_date: null,
			iso_date: null,
			menu: false,
		}
	},
	created() {
		// console.log("Created");
		this.set_dates(this.date)
	},
	methods: {
		set_dates(new_date) {
			const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

			if (new_date == null) {
				this.show_date = null;
				this.iso_date = null;
			} else {
				// this.show_date = new Date(this.date).toISOString().substr(0, 10);
				this.iso_date = this.date_to_iso8601(this.date);


				// For now hardcoded to day month year
				let day = this.date.getDate();
				let month = months[this.date.getMonth()]; // 0 - 11 !!!!
				let year = this.date.getFullYear();

				this.show_date = `${day} ${month} ${year}`;
				
			}
		},
		do_on_change(new_val) {
			this.$emit('on_change', new_val)
		},		
	},
	watch: {
		date(new_date) {
			// console.log("New date " + new_date)

			this.set_dates(new_date);
		},
		iso_date(new_date) {
			// console.log("New iso_date " + new_date)

			let parsed_date = null;
			if (new_date == null) {
				if (this.date != null) {
					this.do_on_change(null)
				}
			} else {
				parsed_date = new Date(new_date);
				if (this.date != parsed_date) {
					// console.log("Date changed from " + this.date + " to " + parsed_date)
					this.do_on_change(parsed_date)
				}
			}
		},
	}
}
</script>